import { useState } from 'react';
import { useDiscipleStore } from '../../../../../store/discipleStore';
import { deleteDisciple as deleteDiscipleApi, getDisciples } from '../apis/disciple-apis';

/**
 * 제자 삭제 관련 로직을 관리하는 커스텀 훅
 */
export const useDeleteDisciple = () => {
  const { setDisciples } = useDiscipleStore();
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string>('');

  /**
   * 제자 삭제 및 DB 동기화
   * @param discipleId 삭제할 제자의 id
   * @returns Promise<void> - 성공 시 resolve, 실패 시 reject
   */
  const deleteDisciple = async (discipleId: number): Promise<void> => {
    if (isDeleting || !discipleId) {
      return Promise.reject(new Error('이미 삭제 중이거나 유효하지 않은 ID입니다.'));
    }

    setIsDeleting(true);
    setError('');

    try {
      // DB에서 삭제
      await deleteDiscipleApi(discipleId);

      // DB에서 최신 리스트 가져오기
      const updatedDisciples = await getDisciples();

      // 스토어 업데이트
      setDisciples(updatedDisciples);
    } catch (err) {
      const errorMessage = '제자 삭제 중 오류가 발생했습니다. 다시 시도해주세요.';
      console.error('제자 삭제 중 오류 발생:', err);
      setError(errorMessage);
      throw err;
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    deleteDisciple,
    isDeleting,
    error,
    clearError: () => setError(''),
  };
};
